module.exports = __webpack_public_path__ + "static/media/note-to-partner.4e6fab4a.svg";